export default {"src":"/_next/static/media/sun-icon.d1651dd7.svg","height":18,"width":18};